import * as api from './index';

export function getProjects(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/projects?${queryString}`);
}

export function getProject(id, query = {}) {
    const queryString = (new URLSearchParams(query)).toString();
    const querySuffix = queryString ? `?${queryString}` : '';
    return api.get(`/projects/${id}${querySuffix}`);
}

export function getProjectWorkOrders(id, query = {}) {
    const queryString = (new URLSearchParams(query)).toString();
    const querySuffix = queryString ? `?${queryString}` : '';
    return api.get(`/projects/${id}/work-orders${querySuffix}`);
}

export function createProject(project) {
    return api.post('/projects', project);
}

export function updateProject(project) {
    return api.patch(`/projects/${project.id}`, project);
}

export function setIsActiveProject(project, isActive) {
    return api.patch(`/projects/${project.id}/isActive`, { isActive });
}

export function softDeleteProject(project) {
    return api.del(`/projects/${project.id}/soft`);
}
